module.exports = __webpack_public_path__ + "static/img/backgroundAdmin.aed77a7f.jpg";